<template>
  <footer class="bg-gray-50 border-t border-gray-200 py-12">
    <div
      class="max-w-6xl mx-auto px-6 flex flex-col md:flex-row justify-between items-center gap-4"
    >
      <span
        class="text-2xl font-black bg-linear-to-r from-pink-500 to-purple-600 bg-clip-text text-transparent"
        ><img src="/assets/logo.svg" class="h-5" title="YouClub"
      /></span>
      <div class="flex gap-6 text-sm">
        <a href="#" class="text-gray-600 hover:text-pink-600">About</a>
        <a href="#" class="text-gray-600 hover:text-pink-600">For Venues</a>
        <a href="#" class="text-gray-600 hover:text-pink-600">Instagram</a>
        <a href="#" class="text-gray-600 hover:text-pink-600">Contact</a>
      </div>
      <span class="text-xs text-gray-400"
        >© 2026 YouClub · the last lonely night out</span
      >
    </div>
  </footer>
</template>
